import React, {useState, useEffect} from "react"
import styled from "styled-components"

export default class ClientRedirect extends React.Component {
  redirects = [
    {
      from: /\/%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B\/?$/i,
      to: "/contact/",
    },
  ];
  componentDidMount() {
    if(window)
    {
      for(const redirect of this.redirects)
      {
        if(window.location.href.match(redirect.from))
        {
          window.location.href = window.location.href.replace(redirect.from, redirect.to);
          break;
        }
      }
    }
  };

  render(){
    return <></>;
  }
}